import {theme as defaultTheme} from '@miro-site/design-tokens'

const footer = {
  background: 'primaryIndigo',
  container: {
    width: [null, 1460],
    margin: '0 auto',
    padding: {
      top: [null, null, 40],
      left: [20, 20, 20, 30],
      right: [20, 20, 20, 30],
      bottom: 40,
    },
  },
  list: {
    margin: -10,
    padding: {
      right: 40,
    },
  },
  item: {
    padding: 10,
  },
  innerItem: {
    margin: {
      top: 6,
    },
  },
  categoryWrapper: {
    margin: {
      bottom: 24,
    },
  },
  categoryTitle: {
    fontSize: 18,
    lineHeight: 24,
    fontWeight: 700,
  },
  bottomContainer: {
    margin: {
      top: [null, null, 100],
    },
    padding: {
      top: 40,
    },
  },
  innerColumn: {
    margin: {
      right: [null, null, 20, 24],
    },
  },
  copyright: {
    margin: {
      right: [20, 20, 20, 24],
    },
  },
  copyrightLink: {
    margin: {
      right: [20, 20, 20, 24],
    },
  },
  icon: {
    margin: {
      left: 12,
    },
  },
  social: {
    margin: {
      top: 30,
      bottom: 26,
    },
  },
  socialItem: {
    margin: {
      left: [20, 20, 20, 24],
    },
  },
  links: {
    menu: {
      borderBottom: '1px solid transparent',
      transition: 'border 250ms ease',

      ':hover': {
        borderColor: 'outspoken',
      },
      ':focus': {
        ...defaultTheme.focus.outlines.withOffset,
      },
    },
    additional: {
      marginTop: 18,
      ':hover .link-text': {
        borderColor: 'outspoken',
      },
    },
    bottom: {
      fontSize: [14, 14, 16],
      lineHeight: 24,

      borderBottom: '1px solid transparent',
      transition: 'border 250ms ease',

      ':hover': {
        borderColor: 'outspoken',
      },
      ':focus': {
        ...defaultTheme.focus.outlines.withOffset,
      },
    },
  },
}

const accordion = {
  background: 'primaryIndigo',
  gutter: 0,
  itemStyles: {
    borderTop: '1px solid #9B99AF',
    ':first-child': {
      borderTop: 0,
    },
  },
  innerList: {
    margin: {
      top: 28,
    },
  },
  innerItem: {
    margin: {
      top: 28,
    },
  },
  categoryWrapper: {
    padding: [20, 24],
  },
  category: {
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 20,
    color: 'white',
  },
  description: {
    fontSize: 14,
    lineHeight: 20,
    color: 'white',
    opacity: '0.8',
    margin: {
      top: 6,
    },
  },
  subcategoryWrapper: {
    padding: {
      left: [20, 34],
      top: 34,
      bottom: 32,
    },
    margin: {
      top: -32,
    },
  },
  subcategory: {
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 24,
    color: 'white',
    margin: {
      top: 30,
    },
  },
  additionalLink: {
    margin: {
      top: 30,
    },
  },
  innerLink: {
    fontSize: 18,
    lineHeight: 24,
  },
}

const theme = {
  ...defaultTheme,
  viewportsArray: ['v2Mobile', 'v2Tablet', 'v2Desktop', 'v2LargeDesktop', 'v2XLargeDesktop'],
  footer,
  accordion,
}

export type Theme = typeof theme

export default theme
